import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import BeforeBeginPortal from 'ContentEditorUI/components/portals/BeforeBeginPortal';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "ExitLayoutModeButton__Container"
})(["z-index:3;position:absolute;top:20px;right:20px;"]);
const ExitLayoutModeButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(BeforeBeginPortal, {
    id: "exit-preview-and-layout-mode-button-container",
    targetElement: document.getElementsByClassName('contentEditor-exitButton')[0],
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Button, {
        use: "tertiary",
        paddingInlineStart: "300",
        paddingInlineEnd: "300",
        paddingBlockEnd: "200",
        "data-action": "exitLayoutMode",
        onClick: onClick,
        children: [/*#__PURE__*/_jsx(RemoveIcon, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "layoutMode.exitLayoutMode"
        })]
      })
    })
  }, "exit-preview-and-layout-mode-button-container");
};
export default ExitLayoutModeButton;